import { TextareaHTMLAttributes, memo, useEffect, useState } from 'react';

import { useFormatedTextChange } from 'core/helpers/text';

const Textarea: React.FC<
  TextareaHTMLAttributes<HTMLTextAreaElement> & { autoSize?: boolean }
> = ({ autoSize, ...props }) => {
  const [textarea, setTextarea] = useState<HTMLTextAreaElement | null>(null);

  const tryResize = () => {
    if (textarea && autoSize) {
      textarea.style.minHeight = '';
      textarea.style.minHeight =
        textarea.style.minHeight = `calc(0.3rem + ${textarea.scrollHeight}px)`;
    }
  };

  useEffect(() => {
    tryResize();
  }, [textarea, props.value]);

  const onkeyDown = useFormatedTextChange<HTMLTextAreaElement>(props.onChange);

  return (
    <textarea
      {...props}
      ref={setTextarea}
      onKeyDown={event => {
        onkeyDown(event); // Ensure custom formatting.

        // MacOS weirdness. It's dissalow catching keyUp & keyPress for keys
        // pressed along with Meta. So we catch them in keyDown.
        if (
          (event.metaKey || event.ctrlKey) &&
          !event.altKey &&
          event.key === 'Enter'
        ) {
          textarea?.closest('form')?.requestSubmit();
        }

        props.onKeyDown?.(event);
      }}
      onChange={props?.onChange}
    />
  );
};

export default memo(Textarea);
